import { v4 as uuidv4 } from "uuid";
import type { BaseBlock } from "@circle-react-shared/BuilderUI/DataModel.types";
import { getBlockSecondaryStyleOptions } from "@circle-react-shared/BuilderUI/DefaultBlocks/utils/stylesHelpers";
import {
  createButtonBlock,
  createH2Block,
  createPBlock,
} from "@circle-react-shared/BuilderUI/DefaultBlocks/utils/textBlocksHelpers";
import { getBackgroundColorOptions } from "@circle-react-shared/BuilderUI/utils/buttonStyleHelpers";
import { getColorOptions } from "@circle-react-shared/BuilderUI/utils/textStyleHelpers";

export const defaultData: BaseBlock = {
  id: uuidv4(),
  type: "EvergreenHomepageBlock10",
  props: {
    header: {
      prop: "children",
      type: "children",
      value: [
        createH2Block({
          text: "Let’s build what you’re meant to teach",
          styles: {
            color: getColorOptions(
              "var(--theme-website-primary-button-default-text-color)",
            ),
          },
        }),
        createPBlock({
          text: "You don’t need another tactic. You need a system that brings your course to life—with clarity, confidence, and purpose. Let’s build it—together.",
          styles: {
            color: getColorOptions(
              "var(--theme-website-primary-button-default-text-color)",
            ),
          },
        }),
      ],
    },
    buttons: {
      prop: "children",
      type: "children",
      value: [
        createButtonBlock({
          text: "Enroll now",
          href: "#",
          buttonType: "secondaryButton",
        }),
        createButtonBlock({
          text: "Schedule a call",
          href: "#",
          buttonType: "customButton",
          styles: {
            default: {
              color: getColorOptions(
                "var(--theme-website-primary-button-default-text-color)",
              ),
              backgroundColor: getBackgroundColorOptions({
                defaultValue: "transparent",
              }),
            },
          },
        }),
      ],
    },
    footer: {
      prop: "children",
      type: "children",
      value: [
        createPBlock({
          text: "Limited spots available. Applications close at the end of the month.",
          paragraphStyle: "p3",
          styles: {
            color: getColorOptions(
              "var(--theme-website-primary-button-default-text-color)",
            ),
          },
        }),
      ],
    },
    styles: {
      prop: "styles",
      type: "styles",
      value: {
        ...getBlockSecondaryStyleOptions(),
        backgroundColor: getBackgroundColorOptions({
          defaultValue: "var(--theme-website-color-6)",
        }),
      },
    },
  },
};
